import { c as _c } from "react/compiler-runtime";
import { PropsWithChildren } from 'react';
import { LinkStyle } from '@sola/ark-core/atoms/link-style/link-style.tsx';
import { cn } from '@sola/ark-core/utils/helpers.ts';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.tsx';
export type AddPaymentMethodButtonProps = {
  purpose?: 'neutral' | 'negative';
  children: React.ReactNode;
};
export const AddPaymentMethodButtonLabel: React.FC<PropsWithChildren> = t0 => {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ArkIcon iconName="plus" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <div className="AddPaymentMethod__button-label flex items-center">{t1}{children}</div>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export const AddPaymentMethodButtonDescription: React.FC<PropsWithChildren> = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <p className="AddPaymentMethod__button-message">{children}</p>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export const AddPaymentMethodButton: React.FC<AddPaymentMethodButtonProps> = t0 => {
  const $ = _c(15);
  let children;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      children,
      purpose: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
    $[3] = t1;
  } else {
    children = $[1];
    props = $[2];
    t1 = $[3];
  }
  const purpose = t1 === undefined ? "neutral" : t1;
  const t2 = purpose === "negative";
  let t3;
  if ($[4] !== t2) {
    t3 = cn(["AddPaymentMethod rounded-md flex justify-center items-center flex-col gap-snug-xl", {
      "AddPaymentMethod--negative": t2
    }]);
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = purpose === "negative" ? "negative" : undefined;
  let t5;
  if ($[6] !== children) {
    t5 = <span className="AddPaymentMethod__add-icon flex flex-col items-center gap-snug-md label-md label-potent lg:label-lg label-action-foreground">{children}</span>;
    $[6] = children;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4 || $[9] !== t5) {
    t6 = <LinkStyle noUnderline={true} noPadding={true} inline={true} variant="primary" purpose={t4}>{t5}</LinkStyle>;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== props || $[12] !== t3 || $[13] !== t6) {
    t7 = <button type="button" className={t3} {...props}>{t6}</button>;
    $[11] = props;
    $[12] = t3;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};